export const GET_AGREEMENTS = 'GET_AGREEMENTS'
export const GET_AGREEMENT = 'GET_AGREEMENT'
export const GET_CURRENT_AGREEMENT = 'GET_CURRENT_AGREEMENT'
